import React, { useEffect } from "react";
import "./coupon.scss";
import { useNavigate } from "react-router-dom";
import userActivePage from "../../../store/userActivePage";
import couponStore from "../../../store/couponStore";
import paymentStore from "../../../store/paymentStore";
import { Button, Grid, IconButton, Stack } from "@mui/material";
import CouponCard from "../../../components/couponCard/CouponCard";
import CouponCardSkeleton from "../../../components/couponCard/CouponCardSkeleton";

const Coupon = () => {
  const navigate = useNavigate();
  const UserActivePage = userActivePage();
  const CouponStore = couponStore();
  const PaymentStore = paymentStore();

  const couponLoading = [1, 2];

  useEffect(() => {
    UserActivePage.setIsActive({ setPage: "coupon" });
    window.scrollTo({ top: 0 });
  }, []);
  return (
    <div className="coupon">
      <Stack spacing={2} className="w-100 transition">
        <div className="page-title">Coupon</div>
        <div className="content">
          <Grid container spacing={2}>
            {CouponStore.isLoading || PaymentStore.isLoading ? (
              couponLoading &&
              couponLoading.map((item) => (
                <Grid
                  item
                  lg={6}
                  md={6}
                  sm={6}
                  xs={12}
                  className="transition"
                  key={item}
                >
                  <CouponCardSkeleton />
                </Grid>
              ))
            ) : CouponStore.coupon ? (
              CouponStore.coupon.map((item) => (
                <Grid
                  item
                  lg={6}
                  md={6}
                  sm={6}
                  xs={12}
                  className="transition"
                  key={item._id}
                >
                  <CouponCard item={item} />
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <div className="no-order-found">
                  <Stack spacing={2}>
                    <div className="title">No coupon code is available</div>
                  </Stack>
                </div>
              </Grid>
            )}
          </Grid>
        </div>
      </Stack>
    </div>
  );
};

export default Coupon;
